import { useEffect, useState } from "react";
import { closeModal, Modal, TextInput } from "risa-oasis-ui_v2";

export const ADD_BUCKET_MODAL_ID = "add-bucket-modal";

interface AddBucketModalProps {
  hasBucket: (name: string, subBucket: string) => boolean;
  onConfirm: (input: { name: string; sub_bucket: string }) => void;
}

const AddBucketModal = ({ hasBucket, onConfirm }: AddBucketModalProps) => {
  const [name, setName] = useState("");
  const [subBucket, setSubBucket] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
  }, [name, subBucket]);

  const reset = () => {
    setName("");
    setSubBucket("");
    setError("");
  };

  const handleSave = () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      setError("Bucket name is required");
      return;
    }
    if (hasBucket(trimmedName, subBucket.trim())) {
      setError(
        "A bucket with this name + sub-bucket combination already exists",
      );
      return;
    }
    onConfirm({ name: trimmedName, sub_bucket: subBucket.trim() });
    reset();
    closeModal(ADD_BUCKET_MODAL_ID);
  };

  return (
    <Modal
      dialogId={ADD_BUCKET_MODAL_ID}
      title="Add New Bucket"
      saveButtonText="Add"
      cancelText="Cancel"
      autoCloseOnSave={false}
      disableSave={!name.trim()}
      onSave={handleSave}
      onCancel={reset}
      onClose={reset}
    >
      <div className="flex flex-col gap-3 py-2">
        <TextInput
          id="add-bucket-name"
          label="Bucket Name"
          placeholder="e.g. Approval on File"
          required
          defaultValue={name}
          error={error}
          onChange={(e) => setName(e.value)}
        />
        <TextInput
          id="add-bucket-sub"
          label="Sub-Bucket (optional)"
          placeholder="e.g. Plan, Pharmacy, Medicare"
          defaultValue={subBucket}
          onChange={(e) => setSubBucket(e.value)}
        />
      </div>
    </Modal>
  );
};

export default AddBucketModal;
